"use strict";
exports.__esModule = true;
var React = require("react");
require("./right-guild.scss");
var stat_1 = require("../stat/stat");
var RightGuild = function () {
    return (React.createElement("div", { className: "p-header__main__cnt__right__item p-header__main__cnt__right__item--guild" },
        React.createElement("a", { href: "//www.yy.com/web/guild_introduce/index.html#/", className: "p-header__main__cnt__right__item__tl", target: "_blank", rel: "noopener noreferrer", onClick: function () {
                stat_1.stat(stat_1.EStatType.GUILD_CLICK);
            } },
            React.createElement("i", { className: "p-header__main__cnt__right__item__tl__icon" }),
            React.createElement("span", { className: "p-header__main__cnt__right__item__tl__t" }, "\u516C\u4F1A"))));
};
exports["default"] = RightGuild;
